/**
 * 语言
 */
export const LANG = {
  // 中文
  ZH: "zh",
  // 英文
  EN: "en",
};
